import React from 'react';
import { AutoComplete, Form, Select, message } from 'antd';
import { useSelector } from 'react-redux';
import { ApplicationState } from 'store';
import TextFilter from '../../../components/TextFilter';
import Swal from 'sweetalert2';
import { SelectCidadeService } from './services';
import type { IGetCidadesResponse } from './services';
import mask from '../../../utils/mask';

interface ISelectCidadeProps {
  codUf?: number;
  setCodCidade: React.Dispatch<React.SetStateAction<number | undefined>>;
}

export const SelectCidade: React.FC<ISelectCidadeProps> = ({ codUf, setCodCidade }) => {
  const { Option } = AutoComplete;
  const parceiros = useSelector((state: ApplicationState) => state.auth.inscricaoAtiva);
  const [response, setResponse] = React.useState<IGetCidadesResponse | undefined>();

  function handleSelect(): void {
    if (parceiros.length === 0) {
      message.warning('Selecione um parceiro para ter acesso a lista de cidades!');
      return;
    }

    if (localStorage.getItem(`responseCidadesFilter${window.location.pathname}`)) {
      const estados = JSON.parse(
        localStorage.getItem(`responseCidadesFilter${window.location.pathname}`) || '{}'
      );
      setResponse(estados);
      return;
    }

    try {
      SelectCidadeService.getCidades(codUf).then((response) => {
        setResponse(response.data);
        localStorage.setItem(
          `responseCidadesFilter${window.location.pathname}`,
          JSON.stringify(response.data)
        );
      });
    } catch (error) {
      Swal.fire({
        title: 'Não foi possivel carregar a lista de estados, por favor tente novamente!',
        html: '',
        icon: 'warning',
        showConfirmButton: false,
      });
    }
  }

  return (
    <Form.Item label={<TextFilter>Cidade</TextFilter>} name="codCidade">
      <Select
        filterOption={(inputValue, option) =>
          option?.value?.toString()?.toUpperCase().indexOf(inputValue?.toUpperCase()) !== -1
        }
        showSearch
        data-testid="select"
        placeholder="Selecione a cidade"
        onFocus={handleSelect}
        onSelect={(_, option) => (setCodCidade ? setCodCidade(Number(option?.key)) : undefined)}
      >
        {response ? (
          response?.cidades?.map((item) => (
            <Option data-testid="select-option" key={item.codCid} value={item.nome}>
              {mask('cidadeUf', item.nome)}
            </Option>
          ))
        ) : (
          <Option value={-1}>Carregando...</Option>
        )}
      </Select>
    </Form.Item>
  );
};
